import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const featuredPost = {
    image: "/images/veloxcharter-choose-right-charter.png",
    category: "Travel Tips",
    title: "How To Choose The Right Charter Transportation For Your Group",
    description:
        "Planning group transportation can be challenging. Learn how to select the right vehicle, determine passenger needs, and ensure a smooth travel experience for every trip.",
    date: "June 12, 2026",
    link: "/blog/choose-the-right-charter",
};

const blogPosts = [
    {
        image: "/images/cooperate-transportation.png",
        category: "Corporate Travel",
        title: "Benefits Of Professional Corporate Transportation Services",
        description:
            "Discover how reliable transportation solutions can improve productivity, professionalism, and employee travel experiences.",
        date: "June 8, 2026",
        link: "/blog/benefits-of-professional-corporate-transportation-services",
    },
    {
        image: "/images/veloxcharter-wedding-events.png",
        category: "Events",
        title: "Transportation Planning For Weddings And Special Events",
        description:
            "Learn how professional transportation can help make your event more organized and stress-free.",
        date: "May 22, 2026",
        link: "/blog/transportation-planning-for-weddings-and-special-events",
    },
    {
        image: "/images/veloxcharter-blog-1.png",
        category: "Fleet & Vehicles",
        title: "Benefits Of Traveling In A Luxury Sprinter Van",
        description:
            "Discover why luxury Sprinter Vans are one of the most popular transportation options for airport transfers, corporate travel, weddings, and private groups.",
        date: "June 18, 2026",
        link: "/blog/benefits-of-traveling-in-a-luxury-sprinter-van",
    },
    {
        image: "/images/group-journey.png",
        category: "Travel Tips",
        title: "How To Plan A Stress-Free Group Journey",
        description:
            "Discover practical tips for organizing group transportation, improving passenger comfort, and ensuring a smooth travel experience from start to finish.",
        date: "June 20, 2026",
        link: "/blog/how-to-plan-a-stress-free-group-journey",
    },
    {
        image: "/images/right-charter-group-van.png",
        category: "Travel Tips",
        title: "How To Choose The Right Charter Transportation For Your Group",
        description:
            "Planning group transportation can be challenging. Learn how to select the right vehicle, determine passenger needs, and ensure a smooth travel experience for every trip.",
        date: "June 12, 2026",
        link: "/blog/choose-the-right-charter",
    },
    {
        image: "/images/business-events.png",
        category: "Corporate Travel",
        title: "The Importance Of Reliable Transportation For Business Events",
        description:
            "Learn why dependable transportation plays a critical role in the success of conferences, meetings, trade shows, and corporate events.",
        date: "June 22, 2026",
        link: "/blog/the-importance-of-reliable-transportation-for-business-events",
    }
];

const Blog = () => {
    const cardsPerPage = 3;

    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(blogPosts.length / cardsPerPage);

    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;

    const currentBlogPosts = blogPosts.slice(startIndex, endIndex);

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
        }
    };

    return (
        <section className="bg-primary">
            <Helmet>
                <title>Blog | Velox Charter</title>

                <meta
                    name="description"
                    content="Read the latest transportation tips, travel guides, and industry insights from Velox Charter. Explore articles about corporate transportation, airport transfers, group travel, luxury Sprinter vans, event transportation, and more."
                />
            </Helmet>

            <div className="max-w-7xl mx-auto px-4">
                <div className="h-[220px] md:h-[280px] flex items-center justify-center">
                    <div className="text-center">

                        <h1 className="text-white text-4xl md:text-6xl font-bold">
                            Blog & Resources
                        </h1>

                        <p className="mt-5 text-white/80 max-w-2xl mx-auto text-base md:text-lg">
                            Transportation insights, travel tips, industry
                            updates, and helpful resources from the Velox Charter team.
                        </p>

                    </div>
                </div>
            </div>

            <section className="bg-white py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="mb-10">
                        <h2 className="text-3xl md:text-4xl font-semibold">
                            Featured Article
                        </h2>
                    </div>

                    <div
                        className="
                            grid
                            lg:grid-cols-2
                            gap-12
                            items-center
                            bg-[#F8FAFC]
                            rounded-[30px]
                            overflow-hidden
                        "
                    >

                        <div>
                            <img
                                src={featuredPost.image}
                                alt={featuredPost.title}
                                className="
                                    w-full
                                    h-[320px]
                                    md:h-[500px]
                                    object-cover
                                "
                            />
                        </div>

                        <div className="p-8 md:p-12">

                            <span
                                className="
                                    inline-block
                                    bg-primary/10
                                    text-primary
                                    px-4
                                    py-2
                                    rounded-full
                                    text-sm
                                    font-medium
                                "
                            >
                                {featuredPost.category}
                            </span>

                            <h3 className="mt-6 text-3xl md:text-4xl font-semibold leading-tight">
                                {featuredPost.title}
                            </h3>

                            <p className="mt-6 text-gray-500 leading-8">
                                {featuredPost.description}
                            </p>

                            <div className="mt-6 flex items-center gap-4 text-sm text-gray-400">
                                <span>{featuredPost.date}</span>
                                <span>•</span>
                            </div>

                            <Link
                                to={featuredPost.link}
                                className="
        inline-block
        mt-8
        bg-primary
        text-white
        px-6
        py-3
        rounded-full
        font-medium
    "
                            >
                                Read Article
                            </Link>
                        </div>

                    </div>

                </div>
            </section>

            <section className="bg-[#F5F5F5] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="mb-12">
                        <h2 className="text-3xl md:text-4xl font-semibold">
                            Recent Articles
                        </h2>
                    </div>

                    <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8">

                        {currentBlogPosts.map((post, index) => (
                            <article
                                key={index}
                                className="
                                    bg-white
                                    rounded-[24px]
                                    overflow-hidden
                                    border
                                    border-[#E5E7EB]
                                    hover:shadow-xl
                                    transition-all
                                    duration-300
                                    hover:-translate-y-2
                                "
                            >

                                <img
                                    src={post.image}
                                    alt={post.title}
                                    className="
                                        w-full
                                        h-[240px]
                                        object-cover
                                    "
                                />

                                <div className="p-6">

                                    <span
                                        className="
                                            inline-block
                                            bg-primary/10
                                            text-primary
                                            px-3
                                            py-1
                                            rounded-full
                                            text-xs
                                            font-medium
                                        "
                                    >
                                        {post.category}
                                    </span>

                                    <h3 className="mt-4 text-xl font-semibold leading-snug">
                                        {post.title}
                                    </h3>

                                    <p className="mt-4 text-gray-500 leading-7">
                                        {post.description}
                                    </p>

                                    <div className="mt-5 flex items-center gap-3 text-sm text-gray-400">
                                        <span>{post.date}</span>
                                        <span>•</span>
                                    </div>

                                    <Link
                                        to={post.link}
                                        className="inline-block mt-6 text-primary font-semibold"
                                    >
                                        Read More →
                                    </Link>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <div className="bg-[#F5F5F5] pb-16">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="flex justify-between items-center">

                        <button
                            onClick={goToPreviousPage}
                            disabled={currentPage === 1}
                            className={`
                    px-5 py-3 rounded-full border
                    flex items-center gap-2
                    transition-all
                    ${currentPage === 1
                                    ? "opacity-50 cursor-not-allowed"
                                    : "hover:bg-primary hover:text-white"}
                `}
                        >
                            ← Previous
                        </button>

                        <button
                            onClick={goToNextPage}
                            disabled={currentPage === totalPages}
                            className={`
                    px-5 py-3 rounded-full border
                    flex items-center gap-2
                    transition-all
                    ${currentPage === totalPages
                                    ? "opacity-50 cursor-not-allowed"
                                    : "hover:bg-primary hover:text-white"}
                `}
                        >
                            Next →
                        </button>

                    </div>

                </div>
            </div>

            <section className="bg-primary py-20">
                <div className="max-w-5xl mx-auto px-4 text-center">

                    <h2 className="text-white text-4xl md:text-5xl font-semibold">
                        Need Transportation For Your Next Trip?
                    </h2>

                    <p className="mt-6 text-white/80 text-lg max-w-3xl mx-auto">
                        Contact our team today and discover transportation
                        solutions tailored to your travel needs.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
                        <Link
                            to="/contact-us"
                            className="
        inline-block
        bg-white
        text-primary
        px-8
        py-4
        rounded-full
        font-semibold
        hover:scale-105
        transition-all
    "
                        >
                            Contact Us
                        </Link>
                    </div>
                </div>
            </section>
        </section>
    );
};

export default Blog;